//import logo from './logo.svg';
import "./App.css";
// import NotificationPrompt from "./components/NotificationPrompt";
import NotificationProvider from "./context/NotificationProvider";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/globals.css";
import { useAutoLogout } from "./hooks/useAutoLogout";
import { Suspense, lazy } from "react";
import SpinningLoader from "./components/common/SpinningLoader";
import Toaster from "./components/primitives/toaster";

const Root = lazy(() => import("./routes/Root"));

function App(): React.ReactElement {
  // Auto-logout timer based on user's security settings
  useAutoLogout();

  return (
    <ThemeProvider>
      <NotificationProvider>
        {/*<NotificationPrompt>*/}
        <Suspense fallback={<SpinningLoader />}>
          <Root />
        </Suspense>
        <Toaster />
        {/*</NotificationPrompt>*/}
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
